import FJProgressModalContainer from './FJProgressModal/FJProgressModalContainer';
import FJRenameModalContainer from './FJRenameModal/FJRenameModalContainer';
import FJWarningModalContainer from './FJWarningModal/FJWarningModalContainer';
import FJDislikeReasonsModalContainer from './FJDislikeReasonsModal/FJDislikeReasonsModalContainer';
import FJGoogleDriveImportModal from '@src/components/FJModals/FJGoogleDriveImport/FJGoogleDriveImportModal.tsx';
import FJGeneratingLoadingModalContainer from '@src/components/FJModals/FJGeneratingLoadingModal/FJGeneratingLoadingModalContainer.tsx';
import FJAdjustDurationModalContainer from '@src/components/FJModals/FJAdjustDurationModal';
import FJShareModal from '@src/components/FJModals/FJShareModal';
import FJAddSocialModal from '@src/components/FJModals/FJAddSocialModal';
import FJPublishHistoryModal from '@src/components/FJModals/FJPublishHistoryModal';

const FJModals = () => {
    return (
        // 在 FJModals 中集成
        <>
            <FJWarningModalContainer />
            <FJGeneratingLoadingModalContainer />
            <FJProgressModalContainer />
            <FJRenameModalContainer />
            <FJDislikeReasonsModalContainer />
            <FJGoogleDriveImportModal />
            <FJAdjustDurationModalContainer />
            <FJShareModal />
            <FJPublishHistoryModal />
            <FJAddSocialModal />
        </>
    );
};
export default FJModals;
